import { type CSSProperties, type PropsWithChildren } from "react";
import "./Card.css";
import Icon from "../../Icon";

type CardProps = PropsWithChildren<{
  containerClass?: string;
  style?: CSSProperties;
  hasCloseIcon?: boolean;
  onCloseIconClick?: () => void;
}>;

export default function Card({
  children,
  containerClass = "",
  style,
  hasCloseIcon,
  onCloseIconClick,
}: CardProps) {
  return (
    <div className={`card ${containerClass}`} style={style}>
      {hasCloseIcon && (
        <Icon
          name="closeCircle"
          onClick={onCloseIconClick}
          className="card--close__icon"
          size={25}
        />
      )}
      {children}
    </div>
  );
}
